import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import VersionSwitcher from '../../ui/docs/VersionSwitcher'

interface DocsHeaderProps {
  version: string
  lang: string
}

function DocsHeader({ version, lang }: DocsHeaderProps) {
  const { t } = useTranslation()

  return (
    <header className='docs-header'>
      <div className='docs-header-content'>
        <div className='docs-header-left'>
          <Link to='/' className='docs-logo'>
            <img src='/logo.png' alt='Runless Logo' className='logo-image' />
            <div className='logo-text'>
              <span className='logo-main'>Runless</span>
              <span className='logo-subtitle'>{t('branding.byCloudSoft')}</span>
            </div>
          </Link>
          <nav className='docs-nav-menu'>
            <Link to='/' className='docs-nav-link'>
              {t('nav.home')}
            </Link>
            <Link to={`/docs/${version}/${lang}`} className='docs-nav-link active'>
              {t('nav.documentation')}
            </Link>
          </nav>
        </div>

        <VersionSwitcher currentVersion={version} currentLang={lang} />
      </div>
    </header>
  )
}

export default DocsHeader
